module.exports = __webpack_public_path__ + "static/media/western-rank.7734ff1d.svg";